/* ==================== Shared custom add-to-cart ====================
   Custom cart buttons request Dawn's cart sections as part of cart/add.js,
   then pass that response to the active cart renderer. This keeps every add
   to one request and leaves native Dawn cart requests untouched. */
(function () {
  'use strict';

  function getCartRenderer() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function fallbackErrorMessage() {
    return (window.cartStrings && window.cartStrings.error) || 'There was an error while updating your cart. Please try again.';
  }

  window.eclatCartErrorMessage = function (error) {
    return (error && error.description) || fallbackErrorMessage();
  };

  window.eclatSetCartError = function (alertElement, error) {
    if (!alertElement) return;
    var message = error ? window.eclatCartErrorMessage(error) : '';
    alertElement.textContent = message;
    alertElement.toggleAttribute('hidden', !message);
  };

  window.eclatAddToCart = function (variantId, quantity) {
    var cart = getCartRenderer();
    var payload = {
      id: Number(variantId),
      quantity: quantity || 1
    };

    if (cart && typeof cart.getSectionsToRender === 'function') {
      payload.sections = cart.getSectionsToRender().map(function (section) { return section.id; });
      payload.sections_url = window.location.pathname;
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
    }

    var cartAddUrl = (window.routes && window.routes.cart_add_url) ||
      (((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/add.js');

    return fetch(cartAddUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(payload)
    }).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (cartResponse) {
        if (!response.ok || cartResponse.status) {
          var error = new Error('cart_add_error');
          error.description = cartResponse.description || cartResponse.message || '';
          throw error;
        }
        return cartResponse;
      });
    });
  };

  window.eclatRenderCart = function (cartResponse) {
    var cart = getCartRenderer();
    if (cart && cartResponse && cartResponse.sections && typeof cart.renderContents === 'function') {
      cart.renderContents(cartResponse);
      return;
    }

    window.location.href = (window.routes && window.routes.cart_url) || '/cart';
  };
})();
